import React from "react";
import UTILS from "../../utils/commons";
import DocumentPreview from "../home/document_preview";
const TransactionItem = ( props ) => {

    var p = props.data;
    return (
        <div className={`px-3 py-3 grid md:grid-cols-7 border-t border-gray-100 text-gray-700 ${props.className}`}>
            {/* <img className="item-image" alt={p.name} src={((p.customerImage) ? p.customerImage : avatar)}  onClick={(id)=>props.onClick(id)}/> */}

            <div className="">{UTILS.formatDate( p.createdAt )}</div>
            <div className="">{p.manager?.firstName || ''} {p.manager?.lastName || ''}</div>
            <div className="">{UTILS.transactionType( p.type )}</div>
            <div className=""><a className="hover:underline" href={`/customers/view/${p.customer.id}`}>{p.customer.name}</a></div>
            {/* <div className=""><a href={`/products/view/${p.product.id}`}>{p.product.productName}</a></div> */}
            {/* <div className="" onClick={( id ) => props.onClick( id )}>{p.quantity}</div> */}
            <div className="font-medium" >{UTILS.thousandSeparator( p.totalAmount )}</div>
            <div className=""><DocumentPreview fileData={p.file} fileName={p.id + '_document'} /></div>
            <div className=""><a className="hover:underline text-primary" href={`/transactions/view/${p.id}`}>View Transaction</a></div>
        </div>
    )
}
export default TransactionItem;